module.exports = __webpack_public_path__ + "img/circle-arrow-right.a7ba5aeb.svg";